<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-security-chain-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-security-chain-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.35637149028078;"
    data-aspect-ratio="0.356"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-security-chain-xs-img"
      class="g-security-chain-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/security-chain-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.8572%;margin-top:-7.5px;left:51.4043%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.1531%;margin-top:-7.5px;left:51.3034%;margin-left:-111px;width:222px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.2198%;margin-top:-6.4px;left:30.8311%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs"
      style="top:12.527%;left:83.7394%;margin-left:-14.0909%;width:28.1818%;"
    >
      <p class="g-pstyle4">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs"
      style="top:15.3348%;left:82.2727%;margin-left:-12.5758%;width:25.1515%;"
    >
      <p class="g-pstyle5">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.047%;margin-top:-6.4px;left:7.9649%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.047%;margin-top:-6.4px;left:95.1246%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:25.7019%;left:19.1002%;margin-left:-11.8182%;width:23.6364%;"
    >
      <p class="g-pstyle6">Sayyid</p>
      <p class="g-pstyle6">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.2892%;margin-top:-14.7px;left:45.4399%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle1">Mohammed-Reza</p>
      <p class="g-pstyle1">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.7277%;margin-top:-7.5px;left:84.1985%;margin-left:-47.5px;width:95px;"
    >
      <p class="g-pstyle1">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.2395%;margin-top:-7.5px;left:84.1822%;margin-left:-44.5px;width:89px;"
    >
      <p class="g-pstyle2">Chief of Staff</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs"
      style="top:28.7257%;left:45.3397%;margin-left:-10.6061%;width:21.2121%;"
    >
      <p class="g-pstyle7">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.1553%;margin-top:-7.5px;left:19.6634%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle2">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.9455%;margin-top:-6.4px;left:12.4544%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.9455%;margin-top:-6.4px;left:40.6297%;margin-left:-21.5px;width:43px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs"
      style="top:41.2527%;left:69.1443%;margin-left:-10.6061%;width:21.2121%;"
    >
      <p class="g-pstyle4">LAW ENFORCEMENT COMMAND</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.9973%;margin-top:-12.4px;left:12.35%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle8">Iran's General</p>
      <p class="g-pstyle8">Armed Forces</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.6453%;margin-top:-18.4px;left:40.6814%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle8">Islamic Revolutionary</p>
      <p class="g-pstyle8">Guards Corps Iran's Elite</p>
      <p class="g-pstyle8">Armed Forces</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.9606%;margin-top:-6.4px;left:29.1491%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.8508%;margin-top:-14.7px;left:12.4087%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle1">Amir</p>
      <p class="g-pstyle1">Hatami</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.8508%;margin-top:-14.7px;left:40.7407%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle1">Mohammad</p>
      <p class="g-pstyle1">Pakpour</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.8508%;margin-top:-14.7px;left:69.0159%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle1">Ahmad</p>
      <p class="g-pstyle1">Reza Radan</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-text g-aiAbs"
      style="top:59.3952%;left:13.3054%;margin-left:-13.3333%;width:26.6667%;"
    >
      <p class="g-pstyle7">Commander-in-Chief of Iranian army</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-text g-aiAbs"
      style="top:59.3952%;left:41.2622%;margin-left:-12.5758%;width:25.1515%;"
    >
      <p class="g-pstyle7">Commander-in-Chief (2)</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:60.205%;margin-top:-7.5px;left:68.9051%;margin-left:-47.5px;width:95px;"
    >
      <p class="g-pstyle2">Chief of police</p>
    </div>
    <div
      id="g-ai0-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5394%;margin-top:-6.4px;left:50.3982%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle8">Other key figures killed</p>
    </div>
    <div
      id="g-ai0-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.0707%;margin-top:-6.4px;left:10.77%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.0707%;margin-top:-6.4px;left:36.2177%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.0707%;margin-top:-6.4px;left:61.8226%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.0707%;margin-top:-6.4px;left:87.7418%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai0-32"
      class="g-text g-aiAbs"
      style="top:76.8898%;left:10.7437%;margin-left:-9.697%;width:19.3939%;"
    >
      <p class="g-pstyle6">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai0-33"
      class="g-text g-aiAbs"
      style="top:76.8898%;left:36.3474%;margin-left:-10.7576%;width:21.5152%;"
    >
      <p class="g-pstyle6">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai0-34"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.6996%;margin-top:-7.5px;left:61.5153%;margin-left:-40.5px;width:81px;"
    >
      <p class="g-pstyle1">Salah Asadi</p>
    </div>
    <div
      id="g-ai0-35"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.4771%;margin-top:-14.7px;left:87.6104%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle1">Hassan Jabal</p>
      <p class="g-pstyle1">Amelian</p>
    </div>
    <div
      id="g-ai0-36"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.989%;margin-top:-14.7px;left:62.7771%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle2">Intelligence</p>
      <p class="g-pstyle2">chief</p>
    </div>
    <div
      id="g-ai0-37"
      class="g-text g-aiAbs"
      style="top:79.9136%;left:87.6284%;margin-left:-10.9091%;width:21.8182%;"
    >
      <p class="g-pstyle7">Head of Iran&rsquo;s advanced weapons program</p>
    </div>
    <div
      id="g-ai0-38"
      class="g-text g-aiAbs"
      style="top:80.0216%;left:10.6877%;margin-left:-6.5152%;width:13.0303%;"
    >
      <p class="g-pstyle7">Defence minister</p>
    </div>
    <div
      id="g-ai0-39"
      class="g-text g-aiAbs"
      style="top:80.0216%;left:36.2826%;margin-left:-12.1212%;width:24.2424%;"
    >
      <p class="g-pstyle7">Head of the military bureau</p>
    </div>
    <div
      id="g-ai0-40"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.2176%;margin-top:-6.4px;right:93.6936%;width:31px;"
    >
      <p class="g-pstyle9">(1)</p>
    </div>
    <div
      id="g-ai0-41"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.2176%;margin-top:-6.4px;right:45.8617%;width:33px;"
    >
      <p class="g-pstyle9">(2)</p>
    </div>
    <div
      id="g-ai0-42"
      class="g-text g-aiAbs"
      style="top:89.7408%;left:55.1412%;width:39.0909%;"
    >
      <p class="g-pstyle10">
        Pakpour was appointed after his predecessor <span class="g-cstyle0"
          >Hossein Salami</span
        >
        was killed during US strikes in 2025. Iran says he will be replaced by
        <span class="g-cstyle0">Ahmad Vahidi.</span>
      </p>
    </div>
    <div
      id="g-ai0-43"
      class="g-text g-aiAbs"
      style="top:89.7408%;left:7.276%;width:39.0909%;"
    >
      <p class="g-pstyle10">
        Mousavi was appointed to second highest commander after Supreme Leader
        when his predecessor <span class="g-cstyle0">Mohammad Bagheri</span> was
        killed during US strikes in 2025.
      </p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.5005%;margin-top:-6.4px;left:62.911%;margin-left:-23.5px;width:47px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-security-chain-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.45987376014427;"
    data-aspect-ratio="0.46"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-security-chain-sm-img"
      class="g-security-chain-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/security-chain-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.1967%;margin-top:-9.1px;left:50.8626%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.6394%;margin-top:-9.1px;left:50.8682%;margin-left:-128px;width:256px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.2595%;margin-top:-7.5px;left:30.3869%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.2595%;margin-top:-7.5px;left:83.5032%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle3">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs"
      style="top:19.2967%;left:83.0006%;margin-left:-9.8039%;width:19.6078%;"
    >
      <p class="g-pstyle4">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.0963%;margin-top:-7.5px;left:8.3077%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.154%;margin-top:-7.5px;left:94.3463%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.505%;margin-top:-17.5px;left:19.3292%;margin-left:-71.5px;width:143px;"
    >
      <p class="g-pstyle1">Sayyid</p>
      <p class="g-pstyle1">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.505%;margin-top:-17.5px;left:44.9%;margin-left:-65px;width:130px;"
    >
      <p class="g-pstyle1">Mohammed-Reza</p>
      <p class="g-pstyle1">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.7233%;margin-top:-9.1px;left:19.2636%;margin-left:-58.5px;width:117px;"
    >
      <p class="g-pstyle2">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:34.7233%;margin-top:-9.1px;left:44.9064%;margin-left:-73.5px;width:147px;"
    >
      <p class="g-pstyle2">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.7152%;margin-top:-9.1px;left:83.4704%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle1">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.1579%;margin-top:-9.1px;left:83.4582%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle2">Chief of Staff</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.0485%;margin-top:-7.5px;left:12.1409%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.1387%;margin-top:-7.5px;left:40.2683%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.7618%;margin-top:-13.4px;left:68.3186%;margin-left:-62.5px;width:125px;"
    >
      <p class="g-pstyle5">LAW ENFORCEMENT</p>
      <p class="g-pstyle5">COMMAND</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.2307%;margin-top:-14.7px;left:12.1186%;margin-left:-46px;width:92px;"
    >
      <p class="g-pstyle6">Iran's General</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.9701%;margin-top:-21.9px;left:40.1909%;margin-left:-72px;width:144px;"
    >
      <p class="g-pstyle6">Islamic Revolutionary</p>
      <p class="g-pstyle6">Guards Corps Iran's Elite</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.402%;margin-top:-7.5px;left:28.7634%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.8107%;margin-top:-17.5px;left:12.1086%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle1">Amir</p>
      <p class="g-pstyle1">Hatami</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.8107%;margin-top:-17.5px;left:40.2093%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle1">Mohammad</p>
      <p class="g-pstyle1">Pakpour</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.8107%;margin-top:-17.5px;left:68.3651%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle1">Ahmad</p>
      <p class="g-pstyle1">Reza Radan</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.6962%;margin-top:-17.5px;left:13.2475%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Iranian army</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-text g-aiAbs"
      style="top:63.1199%;left:40.2537%;margin-left:-12.549%;width:25.098%;"
    >
      <p class="g-pstyle7">Commander-in-Chief (2)</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.0289%;margin-top:-9.1px;left:68.3797%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle2">Chief of police</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.0179%;margin-top:-7.5px;left:49.933%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle6">Other key figures killed</p>
    </div>
    <div
      id="g-ai1-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.117%;margin-top:-7.5px;left:10.4937%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.117%;margin-top:-7.5px;left:35.7901%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.117%;margin-top:-7.5px;left:61.2425%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.117%;margin-top:-7.5px;left:87.0073%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai1-32"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2436%;margin-top:-9.1px;left:10.4114%;margin-left:-58px;width:116px;"
    >
      <p class="g-pstyle1">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai1-33"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2436%;margin-top:-9.1px;left:35.8358%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle1">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai1-34"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2436%;margin-top:-9.1px;left:60.9701%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle1">Salah Asadi</p>
    </div>
    <div
      id="g-ai1-35"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.001%;margin-top:-17.5px;left:86.889%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle1">Hassan Jabal</p>
      <p class="g-pstyle1">Amelian</p>
    </div>
    <div
      id="g-ai1-36"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.5961%;margin-top:-9.1px;left:10.3602%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle2">Defence minister</p>
    </div>
    <div
      id="g-ai1-37"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.3536%;margin-top:-17.5px;left:35.8239%;margin-left:-57.5px;width:115px;"
    >
      <p class="g-pstyle2">Head of the</p>
      <p class="g-pstyle2">military bureau</p>
    </div>
    <div
      id="g-ai1-38"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.3536%;margin-top:-17.5px;left:61.0233%;margin-left:-48.5px;width:97px;"
    >
      <p class="g-pstyle2">Intelligence</p>
      <p class="g-pstyle2">chief</p>
    </div>
    <div
      id="g-ai1-39"
      class="g-text g-aiAbs"
      style="top:84.22%;left:86.8681%;margin-left:-10.8824%;width:21.7647%;"
    >
      <p class="g-pstyle7">Head of Iran&rsquo;s advanced weapons program</p>
    </div>
    <div
      id="g-ai1-40"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.741%;margin-top:-7.5px;right:93.8947%;width:33px;"
    >
      <p class="g-pstyle8">(1)</p>
    </div>
    <div
      id="g-ai1-41"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.741%;margin-top:-7.5px;right:43.4063%;width:35px;"
    >
      <p class="g-pstyle8">(2)</p>
    </div>
    <div
      id="g-ai1-42"
      class="g-text g-aiAbs"
      style="top:92.0649%;left:57.6167%;width:38.8235%;"
    >
      <p class="g-pstyle9">
        Pakpour was appointed after his predecessor <span class="g-cstyle0"
          >Hossein Salami</span
        >
        was killed during US strikes in 2025. Iran says he will be replaced by
        <span class="g-cstyle0">Ahmad Vahidi.</span>
      </p>
    </div>
    <div
      id="g-ai1-43"
      class="g-text g-aiAbs"
      style="top:92.0649%;left:7.0241%;width:38.8235%;"
    >
      <p class="g-pstyle9">
        Mousavi was appointed to second highest commander after Supreme Leader
        when his predecessor <span class="g-cstyle0">Mohammad Bagheri</span> was
        killed during US strikes in 2025.
      </p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.7257%;margin-top:-7.5px;left:62.0232%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-security-chain-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.48387096774194;"
    data-aspect-ratio="0.484"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-security-chain-md-img"
      class="g-security-chain-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/security-chain-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.2393%;margin-top:-9.7px;left:50.9132%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.7056%;margin-top:-9.7px;left:50.8967%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle2">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.5177%;margin-top:-8.6px;left:31.0319%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle3">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.5177%;margin-top:-8.6px;left:82.6083%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle3">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs"
      style="top:19.5015%;left:82.1422%;margin-left:-9.5455%;width:19.0909%;"
    >
      <p class="g-pstyle4">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:27.468%;margin-top:-9.7px;left:9.6345%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.5736%;margin-top:-9.7px;left:93.1194%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.8933%;margin-top:-18.7px;left:20.3042%;margin-left:-80px;width:160px;"
    >
      <p class="g-pstyle1">Sayyid</p>
      <p class="g-pstyle1">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.8933%;margin-top:-18.7px;left:45.1844%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle1">Mohammed-Reza</p>
      <p class="g-pstyle1">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.0194%;margin-top:-9.7px;left:20.3001%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle2">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.0194%;margin-top:-9.7px;left:45.1571%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle2">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.339%;margin-top:-9.7px;left:82.5556%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle1">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.8053%;margin-top:-9.7px;left:82.545%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle2">Chief of Staff</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.8373%;margin-top:-8.6px;left:13.3393%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle3">ARTESH</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.9106%;margin-top:-8.6px;left:40.6176%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle3">IRGC</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.4971%;margin-top:-16.6px;left:67.9137%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle3">LAW ENFORCEMENT</p>
      <p class="g-pstyle3">COMMAND</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.9634%;margin-top:-16.6px;left:13.357%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle5">Iran's General</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.6232%;margin-top:-24.6px;left:40.6235%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle5">Islamic Revolutionary</p>
      <p class="g-pstyle5">Guards Corps Iran's Elite</p>
      <p class="g-pstyle5">Armed Forces</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.3801%;margin-top:-9.7px;left:29.483%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.8053%;margin-top:-18.7px;left:13.312%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle1">Amir</p>
      <p class="g-pstyle1">Hatami</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.8053%;margin-top:-18.7px;left:40.6225%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle1">Mohammad</p>
      <p class="g-pstyle1">Pakpour</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.8053%;margin-top:-18.7px;left:67.8951%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle1">Ahmad</p>
      <p class="g-pstyle1">Reza Radan</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.5912%;margin-top:-18.7px;left:13.3221%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle2">Commander-in-Chief</p>
      <p class="g-pstyle2">of Iranian army</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.9314%;margin-top:-9.7px;left:40.6135%;margin-left:-95px;width:190px;"
    >
      <p class="g-pstyle2">Commander-in-Chief (2)</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.9314%;margin-top:-9.7px;left:67.8971%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle2">Chief of police</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.273%;margin-top:-10.2px;left:49.9997%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle6">Other key figures killed</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.5736%;margin-top:-9.7px;left:11.7557%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.5736%;margin-top:-9.7px;left:36.3012%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.5736%;margin-top:-9.7px;left:60.9982%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:81.5736%;margin-top:-9.7px;left:85.9982%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.773%;margin-top:-9.7px;left:11.6418%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle1">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai2-33"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.773%;margin-top:-9.7px;left:36.4006%;margin-left:-76.5px;width:153px;"
    >
      <p class="g-pstyle1">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai2-34"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.773%;margin-top:-9.7px;left:60.7463%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle1">Salah Asadi</p>
    </div>
    <div
      id="g-ai2-35"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.4328%;margin-top:-18.7px;left:85.8851%;margin-left:-55px;width:110px;"
    >
      <p class="g-pstyle1">Hassan Jabal</p>
      <p class="g-pstyle1">Amelian</p>
    </div>
    <div
      id="g-ai2-36"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.166%;margin-top:-9.7px;left:11.6613%;margin-left:-69.5px;width:139px;"
    >
      <p class="g-pstyle2">Defence minister</p>
    </div>
    <div
      id="g-ai2-37"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.8258%;margin-top:-18.7px;left:36.39%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle2">Head of the</p>
      <p class="g-pstyle2">military bureau</p>
    </div>
    <div
      id="g-ai2-38"
      class="g-text g-aiAbs g-aiPointText"
      style="top:85.8258%;margin-top:-18.7px;left:60.728%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle2">Intelligence</p>
      <p class="g-pstyle2">chief</p>
    </div>
    <div
      id="g-ai2-39"
      class="g-text g-aiAbs"
      style="top:85.8504%;left:85.9091%;margin-left:-10.6061%;width:21.2121%;"
    >
      <p class="g-pstyle7">Head of Iran&rsquo;s advanced weapons program</p>
    </div>
    <div
      id="g-ai2-40"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.4708%;margin-top:-8.6px;right:92.4793%;width:35px;"
    >
      <p class="g-pstyle8">(1)</p>
    </div>
    <div
      id="g-ai2-41"
      class="g-text g-aiAbs"
      style="top:93.8416%;left:8.3883%;width:37.7273%;"
    >
      <p class="g-pstyle9">
        Mousavi was appointed to second highest commander after Supreme Leader
        when his predecessor <span class="g-cstyle0">Mohammad Bagheri</span> was
        killed during US strikes in 2025.
      </p>
    </div>
    <div
      id="g-ai2-42"
      class="g-text g-aiAbs g-aiPointText"
      style="top:94.4708%;margin-top:-8.6px;right:43.3813%;width:38px;"
    >
      <p class="g-pstyle8">(2)</p>
    </div>
    <div
      id="g-ai2-43"
      class="g-text g-aiAbs"
      style="top:93.8416%;left:57.4792%;width:37.7273%;"
    >
      <p class="g-pstyle9">
        Pakpour was appointed after his predecessor <span class="g-cstyle0"
          >Hossein Salami</span
        >
        was killed during US strikes in 2025. Iran says he will be replaced by
        <span class="g-cstyle0">Ahmad Vahidi.</span>
      </p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.6205%;margin-top:-9.7px;left:61.7557%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-security-chain-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 0.80589254766031;"
    data-aspect-ratio="0.806"
    data-min-width="930"
  >
    <div
      id="g-security-chain-lg-img"
      class="g-security-chain-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/security-chain-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs"
      style="top:9.5321%;left:79.1398%;width:9.1398%;"
    >
      <p class="g-pstyle1">Other key figures killed</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.1026%;margin-top:-9.7px;left:31.4008%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle2">Ali Khamenei</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8357%;margin-top:-9.7px;left:31.389%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle3">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.035%;margin-top:-9.7px;left:92.1062%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.8874%;margin-top:-8.6px;left:25.8936%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle4">SECURITY FORCES</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.8874%;margin-top:-8.6px;left:62.4962%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle4">IRANIAN DEFENCE COUNCIL</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs"
      style="top:23.0503%;left:62.1654%;margin-left:-6.7742%;width:13.5484%;"
    >
      <p class="g-pstyle5">Established in 2025 by Khamenei</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.6676%;margin-top:-9.7px;left:84.1759%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle2">Aziz Nasirzadeh</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.9674%;margin-top:-9.7px;left:84.1898%;margin-left:-69.5px;width:139px;"
    >
      <p class="g-pstyle3">Defence minister</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.4666%;margin-top:-9.7px;left:10.7084%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.7664%;margin-top:-9.7px;left:92.1062%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.3192%;margin-top:-9.7px;left:69.9557%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.879%;margin-top:-18.7px;left:18.2804%;margin-left:-80px;width:160px;"
    >
      <p class="g-pstyle2">Sayyid</p>
      <p class="g-pstyle2">Abdolrahim Mousavi</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.879%;margin-top:-18.7px;left:35.9373%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle2">Mohammed-Reza</p>
      <p class="g-pstyle2">Gharaei Ashtiani</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.399%;margin-top:-9.7px;left:84.2198%;margin-left:-76.5px;width:153px;"
    >
      <p class="g-pstyle2">Mohammad Shirazi</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.912%;margin-top:-18.7px;left:84.2122%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle3">Head of the</p>
      <p class="g-pstyle3">military bureau</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.392%;margin-top:-9.7px;left:18.2775%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle3">Chief of Staff (1)</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.392%;margin-top:-9.7px;left:35.918%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle3">Deputy Chief of Staff</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.9518%;margin-top:-9.7px;left:62.4588%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle2">Ali Shamkhani</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.6849%;margin-top:-9.7px;left:62.4513%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle3">Chief of Staff</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.5775%;margin-top:-9.7px;left:92.1062%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.9966%;margin-top:-8.6px;left:13.3375%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle4">ARTESH</p>
    </div>
    <div
      id="g-ai3-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.0833%;margin-top:-8.6px;left:32.6964%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle4">IRGC</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.7765%;margin-top:-16.6px;left:52.0678%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle4">LAW ENFORCEMENT</p>
      <p class="g-pstyle4">COMMAND</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.5096%;margin-top:-16.6px;left:13.3501%;margin-left:-52px;width:104px;"
    >
      <p class="g-pstyle6">Iran's General</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai3-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.2895%;margin-top:-24.6px;left:32.7006%;margin-left:-82.5px;width:165px;"
    >
      <p class="g-pstyle6">Islamic Revolutionary</p>
      <p class="g-pstyle6">Guards Corps Iran's Elite</p>
      <p class="g-pstyle6">Armed Forces</p>
    </div>
    <div
      id="g-ai3-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.2101%;margin-top:-9.7px;left:84.1856%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle2">Salah Asadi</p>
    </div>
    <div
      id="g-ai3-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.5497%;margin-top:-18.7px;left:84.1725%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle3">Intelligence</p>
      <p class="g-pstyle3">chief</p>
    </div>
    <div
      id="g-ai3-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.3019%;margin-top:-9.7px;left:92.1062%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.8218%;margin-top:-9.7px;left:24.7944%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
    <div
      id="g-ai3-32"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.3678%;margin-top:-18.7px;left:84.1765%;margin-left:-55px;width:110px;"
    >
      <p class="g-pstyle2">Hassan Jabal</p>
      <p class="g-pstyle2">Amelian</p>
    </div>
    <div
      id="g-ai3-33"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.2343%;margin-top:-18.7px;left:13.3182%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle2">Amir</p>
      <p class="g-pstyle2">Hatami</p>
    </div>
    <div
      id="g-ai3-34"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.2343%;margin-top:-18.7px;left:32.6998%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle2">Mohammad</p>
      <p class="g-pstyle2">Pakpour</p>
    </div>
    <div
      id="g-ai3-35"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.2343%;margin-top:-18.7px;left:52.0546%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle2">Ahmad</p>
      <p class="g-pstyle2">Reza Radan</p>
    </div>
    <div
      id="g-ai3-36"
      class="g-text g-aiAbs"
      style="top:75.0433%;left:84.1935%;margin-left:-7.5269%;width:15.0538%;"
    >
      <p class="g-pstyle7">Head of Iran&rsquo;s advanced weapons program</p>
    </div>
    <div
      id="g-ai3-37"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.5272%;margin-top:-18.7px;left:13.3254%;margin-left:-85.5px;width:171px;"
    >
      <p class="g-pstyle3">Commander-in-Chief</p>
      <p class="g-pstyle3">of Iranian army</p>
    </div>
    <div
      id="g-ai3-38"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.7473%;margin-top:-9.7px;left:32.6934%;margin-left:-95px;width:190px;"
    >
      <p class="g-pstyle3">Commander-in-Chief (2)</p>
    </div>
    <div
      id="g-ai3-39"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.7473%;margin-top:-9.7px;left:52.056%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle3">Chief of police</p>
    </div>
    <div
      id="g-ai3-40"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.0452%;margin-top:-8.6px;right:92.4047%;width:35px;"
    >
      <p class="g-pstyle8">(1)</p>
    </div>
    <div
      id="g-ai3-41"
      class="g-text g-aiAbs"
      style="top:88.3016%;left:8.2111%;width:26.7742%;"
    >
      <p class="g-pstyle9">
        Mousavi was appointed to second highest commander after Supreme Leader
        when his predecessor <span class="g-cstyle0">Mohammad Bagheri</span> was
        killed during US strikes in 2025.
      </p>
    </div>
    <div
      id="g-ai3-42"
      class="g-text g-aiAbs g-aiPointText"
      style="top:89.0452%;margin-top:-8.6px;right:55.7329%;width:38px;"
    >
      <p class="g-pstyle8">(2)</p>
    </div>
    <div
      id="g-ai3-43"
      class="g-text g-aiAbs"
      style="top:88.3016%;left:44.8777%;width:26.7742%;"
    >
      <p class="g-pstyle9">
        Pakpour was appointed after his predecessor <span class="g-cstyle0"
          >Hossein Salami</span
        >
        was killed during US strikes in 2025. Iran says he will be replaced by
        <span class="g-cstyle0">Ahmad Vahidi.</span>
      </p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.6433%;margin-top:-9.7px;left:39.0955%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-02 16:16 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-02 16:16 -->
<!-- ai file: security-chain.ai -->
<style lang="scss">
  #g-security-chain-box {
    container-type: inline-size;
    container-name: g-security-chain-box;
  }
  #g-security-chain-box,
  #g-security-chain-box .g-artboard {
    margin: 0 auto;
  }
  #g-security-chain-box p {
    margin: 0;
  }
  #g-security-chain-box .g-aiAbs {
    position: absolute;
  }
  #g-security-chain-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-security-chain-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-security-chain-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-security-chain-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-security-chain-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-security-chain-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-security-chain-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-security-chain-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-security-chain-lg {
        display: block !important;
      }
    }
  }
  #g-security-chain-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-security-chain-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 12px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 10px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-security-chain-xs .g-pstyle0 {
    font-weight: 500;
    height: 12px;
    padding-bottom: 5px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-security-chain-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    padding-bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-xs .g-pstyle2 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
    padding-bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-xs .g-pstyle3 {
    font-weight: 400;
    height: 12px;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-security-chain-xs .g-pstyle4 {
    font-weight: 400;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-security-chain-xs .g-pstyle5 {
    font-weight: 300;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-security-chain-xs .g-pstyle6 {
    font-weight: 400;
    line-height: 14px;
    padding-bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-xs .g-pstyle7 {
    font-weight: 700;
    line-height: 14px;
    padding-bottom: 5px;
    font-size: 12px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-xs .g-pstyle8 {
    font-weight: 300;
    height: 12px;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-security-chain-xs .g-pstyle9 {
    font-weight: 300;
    height: 12px;
    padding-bottom: 5px;
    text-align: right;
  }
  #g-security-chain-xs .g-pstyle10 {
    font-weight: 300;
    padding-bottom: 5px;
  }
  #g-security-chain-xs .g-cstyle0 {
    font-weight: 500;
  }
  #g-security-chain-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-security-chain-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-security-chain-sm .g-pstyle0 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 7px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-security-chain-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-sm .g-pstyle3 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 7px;
    text-align: center;
  }
  #g-security-chain-sm .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 7px;
    text-align: center;
  }
  #g-security-chain-sm .g-pstyle5 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    padding-bottom: 7px;
    font-size: 11px;
    text-align: center;
  }
  #g-security-chain-sm .g-pstyle6 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 7px;
    text-align: center;
  }
  #g-security-chain-sm .g-pstyle7 {
    font-weight: 700;
    line-height: 17px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-sm .g-pstyle8 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 7px;
    text-align: right;
  }
  #g-security-chain-sm .g-pstyle9 {
    font-weight: 300;
    padding-bottom: 7px;
  }
  #g-security-chain-sm .g-cstyle0 {
    font-weight: 500;
  }
  #g-security-chain-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-security-chain-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-security-chain-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-security-chain-md .g-pstyle1 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-md .g-pstyle2 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-md .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-md .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-md .g-pstyle5 {
    font-weight: 300;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-md .g-pstyle6 {
    font-weight: 300;
    line-height: 19px;
    height: 19px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-security-chain-md .g-pstyle7 {
    font-weight: 700;
    line-height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-md .g-pstyle8 {
    font-weight: 300;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-security-chain-md .g-pstyle9 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-security-chain-md .g-cstyle0 {
    font-weight: 500;
  }
  #g-security-chain-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-security-chain-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-security-chain-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-security-chain-lg .g-pstyle1 {
    font-weight: 300;
    line-height: 19px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-security-chain-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-lg .g-pstyle3 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-lg .g-pstyle4 {
    font-weight: 400;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-lg .g-pstyle5 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-lg .g-pstyle6 {
    font-weight: 300;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-security-chain-lg .g-pstyle7 {
    font-weight: 700;
    line-height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-security-chain-lg .g-pstyle8 {
    font-weight: 300;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-security-chain-lg .g-pstyle9 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-security-chain-lg .g-cstyle0 {
    font-weight: 500;
  }

  /* Custom CSS */
</style>
